import moment from 'moment';
import { rosterConfig } from '../../roster-config';

const { TIMELINE_HOUR_BLOCK_WIDTH, TIMELINE_CARD_PADDING } = rosterConfig;

/*
  roundUp - Takes an input, and rounds up to the nearest interval.
  If the rounded number is less than the minimum, it'll return the minimum instead.
  eg 0 -> 30, 7 -> 30, 15 -> 30, 30 -> 30, 31 -> 45, 45 -> 45 ... and so forth.
*/
function roundUp(x: number, interval = 15, minimum = 15) {
  let final = 0;

  if (x === 0) {
    final = 0;
  } else if (x % interval > 0) {
    final = (Math.floor(x / interval) + 1) * interval;
  } else {
    final = x;
  }

  return final < minimum ? minimum : final;
}

/* Calculates the offset position for a card based on a date. */
export function getTimelineOffset(date: Date | moment.Moment) {
  const mStartDate = moment(date);
  const minutes = roundUp(mStartDate.hours() * 60 + mStartDate.minutes(), 1, 0);
  return (minutes / 60) * TIMELINE_HOUR_BLOCK_WIDTH + TIMELINE_CARD_PADDING;
}

/* Calculates the width of a position based on start/end dates.  */
export function getTimelineCardWidth(
  startDate: Date | moment.Moment,
  endDate: Date | moment.Moment,
  baseWidth = TIMELINE_HOUR_BLOCK_WIDTH,
) {
  const mStartDate = moment(startDate);
  let mEndDate = moment(endDate);

  if (!mStartDate.isSame(mEndDate, 'day')) {
    mEndDate = moment(mStartDate).endOf('day');
  }

  let minutesDiff = 0;

  minutesDiff = roundUp(mEndDate.diff(mStartDate, 'minutes'), 1, 13);
  return (minutesDiff / 60) * baseWidth - TIMELINE_CARD_PADDING * 2;
}
